<template>
  <path
    d="M18 10.0002V13.0002H6V10.0002C6 9.45024 5.55 9.00024 5 9.00024C4.45 9.00024 4 9.45024 4 10.0002V14.0002C4 14.5502 4.45 15.0002 5 15.0002H19C19.55 15.0002 20 14.5502 20 14.0002V10.0002C20 9.45024 19.55 9.00024 19 9.00024C18.45 9.00024 18 9.45024 18 10.0002Z"
  />
</template>
